import React from "react";
import { useSettingsService } from "serviceHooks";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

function useInvoiceSettings() {
  const settingsService = useSettingsService();

  const [invoiceSettings, setInvoiceSettings] = React.useState<WintSuperkollAPIModel.InvoiceSettings>();

  React.useEffect(() => {
    const fetchInvoiceSettings = async () => {
      const invoiceSettings = await settingsService.getCustomerInvoiceSettings();
      setInvoiceSettings(invoiceSettings);
    };
    fetchInvoiceSettings();
  }, []);

  return { invoiceSettings };
}

export default useInvoiceSettings;
